import BodyText from "./BodyText";
import Box from "./Box";
import ExpandableSection from "./ExpandableSection";
import Line from "./Line";
import PropTypes from "prop-types";
import React from "react";
import SmallCaps from "./SmallCaps";

function ProductNotes({ label, conditionNotes }) {
  return (
    <>
      <ExpandableSection
        content={<BodyText>{conditionNotes}</BodyText>}
        heading={
          <Box py={[10, null, "5px", null]}>
            <SmallCaps>{label}</SmallCaps>
          </Box>
        }
        chevronColor="black"
        openByDefault
      />
      <Line />
    </>
  );
}

export default ProductNotes;

ProductNotes.propTypes = {
  conditionNotes: PropTypes.string.isRequired,
};
